module.exports = __webpack_public_path__ + "media/images/payments/payza-2469f6fce1f4d6b50aa18902b03b7c77.svg";